import { useDispatch, useSelector } from 'react-redux';

import { openUploadModal } from 'components/Layouts/Form/FormBuilder/Content/AddNewContent/uploadModal';
import { useLandingV2Context } from 'detailsv2/LandingV2/context';
import useAssetsPermissions from 'hooks/useAssetsPermissions';
import { isOwnerSelector } from 'store/user/selectors';
import { DOCUMENT_MIME_TYPES, MEDIA_MIME_TYPES } from 'utils/asset';

import { EBlockType, IBlock } from '../../../../../../__blocks';
import { getModalTitleText } from '../../../functions';
import { IUseUpload } from './types';

export const useUpload = <T extends IBlock<EBlockType.Image> | IBlock<EBlockType.Document>>({
  availableInBasic,
  type,
  onUpdate,
  data,
}: IUseUpload<T>) => {
  const dispatch = useDispatch();
  const isOwner = useSelector(isOwnerSelector);
  const uploadModalType = type || 'media';
  const isDocument = uploadModalType === 'document';
  const descText = isDocument ? 'documents' : 'photos';
  const { withAssetSettings } = useAssetsPermissions();
  const { data: page } = useLandingV2Context();
  const currentPage = page;

  const getMimeType = (type: string) => {
    switch (type) {
      case 'media':
        return MEDIA_MIME_TYPES;
      case 'document':
        return DOCUMENT_MIME_TYPES;
      default:
        return MEDIA_MIME_TYPES;
    }
  };

  const openModal = async () => {
    const modalTitle = getModalTitleText(uploadModalType);
    // @ts-ignore
    const assets = await openUploadModal(dispatch, {
      type: uploadModalType,
      modalTitle,
      suggested: currentPage,
      isSortingEnabled: true,
      isOwner,
      withAssetSettings,
      defaults: {
        name: 'name' in currentPage ? currentPage.name : null,
        tags: 'tags' in currentPage ? currentPage.tags : null,
      },
    });

    if (assets === null) {
      return;
    }

    onUpdate?.<T>({
      ...data,
      availableInBasic,
      data: {
        files: assets,
      },
    });
  };

  return { descText, uploadModalType, getMimeType, openModal, getModalTitleText };
};
